import { MessageSquare, HelpCircle, UserCheck, Clock, Sparkles, BarChart3 } from "lucide-react";

export const ReplyDeliverabilityStrategies = () => {
  const strategies = [
    {
      icon: HelpCircle,
      title: "End Every Email with a Question",
      description: "Transform statements into questions. Instead of 'Let me know if you're interested,' ask 'What's your biggest challenge with [topic] right now?' Questions demand responses.",
      tip: "Open-ended questions work better than yes/no questions for reply rates",
    },
    {
      icon: MessageSquare,
      title: "Write Conversationally, Not Promotionally",
      description: "Emails that sound like broadcasts get ignored. Write like you're messaging a colleague—short sentences, casual tone, and genuine curiosity about the recipient.",
      tip: "Remove all marketing speak: 'leverage,' 'synergy,' 'solutions'",
    },
    {
      icon: UserCheck,
      title: "Personalize Beyond First Name",
      description: "Generic personalization is obvious. Reference something specific: their recent post, company news, or mutual connection. Real personalization shows you did your homework.",
      tip: "Mention something from the last 30 days for maximum relevance",
    },
    {
      icon: Clock,
      title: "Send at Reply-Friendly Times",
      description: "Don't send when people are drowning in email. Mid-morning and mid-afternoon during their local business hours give recipients mental space to compose a response.",
      tip: "Tuesday-Thursday 10-11am and 2-3pm in recipient's timezone",
    },
    {
      icon: Sparkles,
      title: "Make Replies Easy",
      description: "Lower the effort required to respond. Ask for a simple 'yes' or 'no,' or provide numbered options: 'Reply 1 for option A, 2 for option B.' Reduce friction to increase action.",
      tip: "The easier the reply, the higher the response rate",
    },
    {
      icon: BarChart3,
      title: "Track Reply Rate as Primary KPI",
      description: "Update your dashboards. Open rate goes to secondary metrics; reply rate becomes the north star. Set benchmarks: 5% reply rate for cold outreach, 15%+ for warm sequences.",
      tip: "Benchmark: 5% cold, 10% warm, 15%+ engaged lists",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Strategies for Reply-First Email
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Transitioning from open-focused to reply-focused email requires rethinking every part of your 
        strategy—from copy to timing to measurement.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {strategies.map((strategy, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
              <strategy.icon className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">{strategy.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{strategy.description}</p>
            <div className="text-xs text-primary bg-primary/5 p-3 rounded-lg">
              <strong>Pro tip:</strong> {strategy.tip}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};